// ── THE CUSTOMER'S CHECKOUT CURRENCY CHOICE (FOUNDER CHECKOUT REQUEST 2026-10-27) ─────────────────────────────────────────────
// The header currency picker (design runtime state `cur`) publishes the customer's CHOICE as `window.__SG_CUR` and fires
// "sg:cartquotechange", so every server quote is re-asked in that currency. This module only reads the choice: an ISO code, never
// an amount or a rate. The server prices (CAD source prices, converted by its own FX source when the choice is not CAD) and states
// the currency it priced in; a quote in any other currency than the one chosen is refused by the caller, never relabelled.

export const DEFAULT_CHECKOUT_CURRENCY = "CAD";

/** The chosen currency as an upper-case ISO-4217 code. Missing or malformed → CAD (the source-price currency), never a guess. */
export function normalizeCheckoutCurrency(v: unknown): string {
  if (typeof v !== "string") return DEFAULT_CHECKOUT_CURRENCY;
  const code = v.trim().toUpperCase();
  return /^[A-Z]{3}$/.test(code) ? code : DEFAULT_CHECKOUT_CURRENCY;
}

/** The current choice in this browser (CAD outside a browser). */
export function readCheckoutCurrency(): string {
  if (typeof window === "undefined") return DEFAULT_CHECKOUT_CURRENCY;
  return normalizeCheckoutCurrency((window as unknown as { __SG_CUR?: unknown }).__SG_CUR);
}
